import { Outlet } from 'react-router-dom';
import { System } from '@/components/layout/system';
import { Version } from '@/components';
import { useEffect } from 'react';

export function SystemLayout() {
  useEffect(() => {
    // If dark mode
    document.body.classList.add('dark');
  }, []);
  return (
    <div className='h-full min-h-screen flex flex-col'>
      <System />
      <main id='system_layout_main' className='flex-1 bg-[#F5F7FB] dark:bg-[#1A1A1A]'>
        <Outlet />
      </main>
      <Version />
    </div>
  );
}
